var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4096 12.0006L2.95508 4.54607L4.54607 2.95508L12.0006 10.4096L19.4551 2.95508L21.0461 4.54607L13.5916 12.0006L21.0461 19.4551L19.4551 21.0461L12.0006 13.5916L4.54607 21.0461L2.95508 19.4551L10.4096 12.0006Z",
    fill: "#482714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveImageIcon);
export default __webpack_public_path__ + "static/media/remove-image-icon.30ed176a3e0c8cb79a04ccfee31a0af8.svg";
export { ForwardRef as ReactComponent };